import styled from 'styled-components';
export var Inner = styled.div.withConfig({
  displayName: "Inner",
  componentId: "sc-1nnthk4-0"
})(["display:block;display:flex;flex-flow:column;max-width:600px;min-height:400px;padding:7px 9px;margin:", " auto 16px;margin-bottom:0;"], function (_ref) {
  var isCompact = _ref.isCompact;
  return isCompact ? '4px' : '20px';
});
export var Results = styled.div.withConfig({
  displayName: "Inner__Results",
  componentId: "sc-1nnthk4-1"
})(["display:block;overflow-y:scroll;max-height:220px;max-height:280px;"]);
export var Title = styled.div.withConfig({
  displayName: "Inner__Title",
  componentId: "sc-1nnthk4-2"
})(["margin-bottom:32px;text-align:center;"]);
export var Footer = styled.div.withConfig({
  displayName: "Inner__Footer",
  componentId: "sc-1nnthk4-3"
})(["padding:6px;border-top:1px solid ", ";margin-top:auto;"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.uiL;
});